import { useEffect, useCallback, useState } from 'react'

// custom component
import PlaceholderText from '../../components/common/PlaceholderText'
import Layout from '../../layouts/common/Layout'
import FacilityList from '../../components/FacilityList/FacilityList'
import FacilityGlobalFilterForm from '../../components/FacilityGlobalFilterForm/FacilityGlobalFilterForm'


// constants

// css
import './facilities.css'
import { useAxiosPrivate, useDocumentTitle } from '../../hooks'
import { PAGE_TITLE } from '../../constants/constants'
import Loader from '../../components/common/Loader'
import { Paper } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchFacilities,
  getFacilities,
  getFetchError,
  getUpdateError,
  getFetchLoading,
  getUpdateLoading,
  updateFacilityStatus,
} from '../slices/facility.slice'

const Facilities = () => {
  const [updatingRowId, setUpdatingRowId] = useState(null)
  const dispatch = useDispatch()
  const facilitiesData = useSelector(getFacilities)
  const fetchLoading = useSelector(getFetchLoading)
  const updateLoading = useSelector(getUpdateLoading)
  const fetchError = useSelector(getFetchError)
  const updateError = useSelector(getUpdateError)

  // updating the page title
  useDocumentTitle(PAGE_TITLE.FACILITIES)
  const axiosPrivate = useAxiosPrivate()

  const fetchFilteredFacilities = useCallback(
    (filterParam, query) => {
      const customParams = {
        pageNo: 0,
        pageSize: 100,
      }
      if (filterParam) {
        customParams[filterParam.value] = query
      }
      dispatch(
        fetchFacilities({ axiosInstance: axiosPrivate, params: customParams })
      )
    },
    [axiosPrivate, dispatch]
  )

  useEffect(() => {
    // Fetch initial data when component mounts
    dispatch(
      fetchFacilities({
        axiosInstance: axiosPrivate,
        params: { pageNo: 0, pageSize: 100 },
      })
    )
  }, [axiosPrivate, dispatch])

  const handleStatusChange = useCallback(
    (checked, params) => {
      setUpdatingRowId(params?.row?.id) // Track the updating row
      dispatch(
        updateFacilityStatus({
          axiosInstance: axiosPrivate,
          facilityId: params?.row?.id,
          active: !params?.row?._active,
        })
      ).finally(() => setUpdatingRowId(null)) // Reset after update
    },
    [axiosPrivate, dispatch]
  )

  const renderContent = () => {
    if (fetchLoading) {
      return <Loader />
    }

    if (fetchError || updateError) {
      if (fetchError?.status === 404 || updateError?.status === 404) {
        return (
          <Layout.CenterWrapper>
            <PlaceholderText fontSize='2rem'>No facilities found</PlaceholderText>
          </Layout.CenterWrapper>
        )
      }
      return (
        <Layout.CenterWrapper>
          <PlaceholderText  fontSize='2rem' color='error'>
            {fetchError?.message || updateError?.message || 'Oops something went wrong'}
          </PlaceholderText>
        </Layout.CenterWrapper>
      )
    }

    return (
      <>
        <Paper
          className="global-filter-panel"
          sx={{
            padding: 3,
            marginBottom: 3,
          }}
        >
          <FacilityGlobalFilterForm getFilteredData={fetchFilteredFacilities} />
        </Paper>
        <div className="grid-panel">
          <FacilityList
            data={facilitiesData}
            onStatusChange={handleStatusChange}
            statusLoading={updateLoading}
            statusError={updateError}
            updatingRowId={updatingRowId} // Pass the updating row ID
          />
        </div>
      </>
    )
  }

  return <Layout.CenterWrapper>{renderContent()}</Layout.CenterWrapper>
}

export default Facilities
